import { deprecated } from "typesafe-actions";
import { IServerError } from "./types";

const createAction = deprecated.createAction;

export const addServerError = createAction(
  "ADD_SERVER_ERROR",
  (resolve) => (error: IServerError) => resolve(error),
);
